module.exports = __webpack_public_path__ + "static/23-8bb9f2270c350af1ad044ef1468c1bbd.png";